import React from 'react';
import cn from 'classnames';
import Image from 'next/image';
import styles from './design-brand.module.css';
import { Container } from '../../components';

export default function DesignBrand() {
  return (
    <section className={styles.root}>
      <Container>
        <h2 className={styles.title} id="brand">
          Brand Identity
        </h2>
        <div className={styles.row}>
          <p className={styles.text}>
            A brand sets you apart from everyone else and makes a statement
            about you. It&apos;s like a signature that highlights everything it
            touches. To create the unique branding for your project you&apos;ll
            start with the filling of special questionnaire.
          </p>
          <div className={styles.box}>
            <span className={styles.counter}>03</span>
            <span className={styles.subtitle}>Sketching</span>
          </div>
        </div>
        <div className={styles.design}>
          <div className={styles.start}>
            <div className={styles.colors}>
              <div className={styles['design_colors-row']}>
                <h3
                  className={cn(styles['design_colors-title'], styles.center)}
                >
                  Main Colors
                </h3>
                <div className={styles.design_colors}>
                  <div className={styles.design_color}>
                    <div
                      className={styles.design_circle}
                      style={{ backgroundColor: '#005448' }}
                    />
                    <p
                      className={styles.design_code}
                      style={{ textAlign: 'left' }}
                    >
                      #005448
                    </p>
                  </div>
                  <div className={styles.design_color}>
                    <div
                      className={styles.design_circle}
                      style={{ backgroundColor: '#8CB2AC' }}
                    />
                    <p
                      className={styles.design_code}
                      style={{ textAlign: 'center' }}
                    >
                      #8CB2AC
                    </p>
                  </div>
                  <div className={styles.design_color}>
                    <div
                      className={styles.design_circle}
                      style={{ backgroundColor: '#3D7C74' }}
                    />
                    <p
                      className={styles.design_code}
                      style={{ textAlign: 'right' }}
                    >
                      #3D7C74
                    </p>
                  </div>
                </div>
              </div>
              <div className={styles['design_colors-row']}>
                <h3
                  className={cn(styles['design_colors-title'], styles.center)}
                >
                  Secondary Colors
                </h3>
                <div className={styles.design_colors}>
                  <div className={styles.design_color}>
                    <div
                      className={styles.design_circle}
                      style={{
                        backgroundColor: '#B3CCC8',
                      }}
                    />
                    <p
                      className={styles.design_code}
                      style={{ textAlign: 'left' }}
                    >
                      #B3CCC8
                    </p>
                  </div>
                  <div className={styles.design_color}>
                    <div
                      className={styles.design_circle}
                      style={{ backgroundColor: '#9DBDB9' }}
                    />
                    <p
                      className={styles.design_code}
                      style={{ textAlign: 'center' }}
                    >
                      #9DBDB9
                    </p>
                  </div>
                  <div className={styles.design_color}>
                    <div
                      className={styles.design_circle}
                      style={{ backgroundColor: '#ABABAB' }}
                    />
                    <p
                      className={styles.design_code}
                      style={{ textAlign: 'right' }}
                    >
                      #ABABAB
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.fonts}>
              <h3 className={cn(styles['design_colors-title'], styles.center)}>
                Bellota
              </h3>
              <img
                alt="bellota fonts"
                className={styles['fonts-image']}
                src="/design/brand/fonts.svg"
              />
            </div>
          </div>
          <div className={styles.end}>
            <div className={styles.logos}>
              <h3 className={cn(styles['design_colors-title'], styles.center)}>
                Logo
              </h3>
              <Image
                alt="keto kitchen logo"
                src="/keto/logo-images/logo.png"
                width={513}
                height={250}
              />
            </div>
            <div className={styles.icons}>
              <h3 className={cn(styles['design_colors-title'], styles.center)}>
                Icons
              </h3>
              <Image
                alt="custom icons"
                src="/keto/icons-images/icons.png"
                width={661}
                height={482}
              />
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}
